import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Coordinates } from './geolocation.service';
import { LocationWeather } from './weather.model';

const OPEN_WEATHER_MAP_URL = 'https://api.openweathermap.org/data/2.5/weather';

@Injectable({
  providedIn: 'root',
})
export class WeatherService {
  constructor(private httpClient: HttpClient) {}

  getByCoordinates(coordinates: Coordinates) {
    return this.httpClient
      .get<OpenWeatherMapResponse>(OPEN_WEATHER_MAP_URL, {
        params: {
          lat: coordinates.latitude.toString(),
          lon: coordinates.longitude.toString(),
          units: 'metric',
          appid: environment.openWeatherApiKey,
        },
      })
      .pipe(map((response) => this.toLocationWeather(response)));
  }

  private toLocationWeather(response: OpenWeatherMapResponse): LocationWeather {
    return {
      city: response.name,
      country: response.sys.country,
      temperatureCelsius: Math.round(response.main.temp),
    };
  }
}

interface OpenWeatherMapResponse {
  name: string;
  sys: { country: string };
  main: { temp: number };
}
